import Autoform from './Autoform';
import useAutoformLoadMetadata from './hooks/useAutoformLoadMetadata';
import DefinitionsSkeleton from '../utils/DefinitionsSkeleton';

const AutoformContainer = ({
    autoformId,
    itemId,
    onNodeRename,
    onNodeItemDelete,
    portfolioItem,
    onNodeOwnershipPercentageUpdate,
}) => {
    const { isLoading } = useAutoformLoadMetadata(autoformId);

    if (isLoading) return <DefinitionsSkeleton />;

    return (
        <Autoform
            itemId={itemId}
            onNodeRename={onNodeRename}
            onNodeItemDelete={onNodeItemDelete}
            portfolioItem={portfolioItem}
            onNodeOwnershipPercentageUpdate={onNodeOwnershipPercentageUpdate}
        />
    );
};

export default AutoformContainer;
